"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SelectDropdown_styles_1 = require("./SelectDropdown.styles");
const Chevron_1 = __importDefault(require("../Chevron"));
const SelectDropdown = ({ value, onChange, validationError, options, placeholder, id, name, }) => {
    return (react_1.default.createElement(SelectDropdown_styles_1.StyledSelectDropdown, { "$isError": !!validationError },
        react_1.default.createElement(SelectDropdown_styles_1.StyledSelectField, { value: value, onChange: onChange, id: id, name: name },
            react_1.default.createElement("option", { value: "", disabled: true }, placeholder),
            options.map((option) => (react_1.default.createElement("option", { key: option.value, value: option.value }, option.label)))),
        react_1.default.createElement(Chevron_1.default, null)));
};
exports.default = SelectDropdown;
